module.exports = __webpack_public_path__ + "img/icon-search.bbc1db03.svg";